<template>
	<div>
		<CPermissionOverrideDialog
			:entity-id="entityId"
			:show="internalVisible"
			:is-folder="isFolder"
			:is-nested-form="isNestedForm"
			:name="name"
			:users="users"
			:roles="roles"
			@close="internalVisible = false"
			@closed="$emit('closed')"
			@permissions-changed="getUsers"
		/>
		<CUpsellDialog :show="!canChangeFolderPermissions && isFolder" :org-code="orgCode" :is-org-owner="isOrgOwner" feature="folderpermissions" @closed="$emit('closed')" />
	</div>
</template>

<script lang="ts">
	import CPermissionOverrideDialog from './PermissionOverrideDialog.vue';
	import CUpsellDialog from './UpsellDialog.vue';
	import { computed, defineComponent, ref, watch } from 'vue';
	import { getFolderUsers, getFormUsers, getWorkflowRoles } from '@cognitoforms/api/services/form-permission-service';
	import type { WorkflowRoleModel } from '@cognitoforms/types/server-types/model/workflow-role-model';
	import type { UserPermissionModel } from '@cognitoforms/types/server-types/model/user-permission-model';
	import { globalStore } from 'src/stores/global-store';

	export default defineComponent({
		name: 'CPermissionOverrideContainer',
		components: {
			CPermissionOverrideDialog,
			CUpsellDialog
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			entityId: {
				type: String,
				default: ''
			},
			name: {
				type: String,
				default: ''
			},
			isFolder: {
				type: Boolean,
				default: false
			},
			canChangeFolderPermissions: {
				type: Boolean,
				default: false
			},
			orgCode: {
				type: String,
				required: true
			},
			isOrgOwner: {
				type: Boolean,
				default: false
			}
		},
		emits: ['closed'],
		setup(props) {
			const users = ref<UserPermissionModel[]>(null);
			const roles = ref<WorkflowRoleModel[]>(null);

			const isNestedForm = computed(() => {
				return (props.isFolder) ? false : globalStore.allForms[props.entityId]?.FolderId != null;
			});

			const getUsers = async () => {
				if (props.isFolder) {
					const res = await getFolderUsers(props.entityId);
					users.value = res;
				}
				else {
					const res = await getFormUsers(props.entityId);
					users.value = res;
				}
			};

			const getRoles = async () => {
				roles.value = await getWorkflowRoles(props.entityId);
			};

			const internalVisible = ref(false);
			watch (() => props.show, (show) => {
				if (!show)
					return;

				internalVisible.value = (!props.isFolder || props.canChangeFolderPermissions);
				getUsers();

				if (!props.isFolder)
					getRoles();
			}, { immediate: true });

			return {
				users,
				roles,
				isNestedForm,
				getUsers,
				internalVisible
			};
		}
	});
</script>